export default __webpack_public_path__ + "static/media/automation3.06e0ee8f.png";